<template>
    <h3 class="mt-l">Extend key duration</h3>
    <p>The expiry time of a key can be set from the current time point by maximum of {{time_limit/3600}} hours.</p>
    <form @submit.prevent="extendKey" class="mt-s" v-click-outside="clearErrorMsg">
        <div :class="{'error' : alert.successful === false }">
            <div><label for="extension">Expire after (hours)</label></div>
            <input type="text" v-model="expire_after_h" id="extension" aria-required="true" />
            <button type="submit" id="extend-button" class="ml-s">Set expiration</button>
        </div>
    </form>
    <AlertBox v-if="alert.msg != ''"
        :alertMsg="alert.msg"
        :successful="alert.successful"
    />
</template>

<script>

import axios from 'axios';
import AlertBox from './AlertBox.vue';

export default {
    name: 'KeyExtension',
    props: ['prjnum', 'access_key', 'time_left'],
    emits: ['key-extended'],
    components: {
        AlertBox
    },
    data() {
        return {
            extend_by_h: '',
            alert: { msg: '', successful: Boolean},
        }
    },
    methods: {
        checkIfInt(str) {
            let num = Number(str);
            return Number.isInteger(num);
        },
        checkInput() {
            if (this.extend_by_ === '' ) this.alert = { msg: "Hours are required", successful: false };
            else if (!this.checkIfInt(this.expire_after_h)) this.alert = { msg: "Enter a whole number", successful: false };
            else if (this.expire_after_h > this.time_limit ) this.alert = { msg: "Duration may not exceed " + this.time_limit + " hours", successful: false };
            else if (this.expire_after_h <= 0) this.alert = { msg: "Enter a positive number", successful: false };
            else if (this.time_limit === undefined) this.alert = { msg: "Error. Try again later", successful: false }; /**error getting API limits for extension*/
            else this.alert = { msg: '', successful: true };
        },
        extendKey() {
            this.checkInput();

            if (this.alert.successful) {
                let url = '/api/v1/project/' + this.prjnum + '/key/' + this.access_key;
                let data = {"expire_after": this.expire_after_h * 3600};

                axios.put(url, data)
                .then(() => {
                    this.$emit('key-extended');
                    this.expire_after_h = '';
                    this.alert = {msg: "Expiration set successfully", successful: true};
                })
                .catch(error => {
                    this.alert = {msg: "Error. Try again later", successful: false};
                    console.log(error.response.status, error.response.statusText);
                });
            }
        },
        reset() {
            this.alert = { msg: "", successful: Boolean};
            this.extend_by = '';
        },
        clearErrorMsg() {
            if (!this.alert.successful) this.alert = {...this.alert, msg: ""};
        }
    },
    computed: {
        time_limit() {
            return this.$store.state.keyLimits.max_key_live_duration;
        }
    },
    watch: {
        alert(newVal) {
            if (newVal.successful === true) {
                setTimeout(() => this.reset(), 3000);
            }
        }
    }
}

</script>

<style scoped>

.error, .error label {
    color: var(--red);
}

.error input {
    border: 1px solid var(--red);
}

input {
    width: 9rem;
}

#extend-button {
    display: inline-block;
}
</style>
